import React from "react"
import { Box, componentStyles } from "@mallardbay/lib-react-components"

import SearchResults from "~components/pages/search/search-results"
import { SEARCH_PAGE_SIZE } from "~config/constants"
import Pagination from "~components/shared/pagination/pagination"
import PaginationSummary from "~components/shared/pagination/pagination-summary"
import { useSearch } from "~components/providers/search-provider"
import Spinner from "~components/shared/todo-lib-react-components/spinner"

export default function SearchResultsContainer() {
    const styles = useStyles()
    const { total, isLoading, currentPage, onPageChange } = useSearch()

    if (isLoading) return <Spinner />

    return (
        <>
            <SearchResults />
            {total > SEARCH_PAGE_SIZE && (
                <Box style={styles.pagination}>
                    <Pagination
                        total={total}
                        current={currentPage}
                        onChange={onPageChange}
                    />
                    <PaginationSummary total={total} current={currentPage} />
                </Box>
            )}
        </>
    )
}

function useStyles() {
    return componentStyles({
        pagination: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "48px",
        },
    })
}
